/**
 * Extract expiration time from a JWT token payload (`exp` claim).
 * Never logs token contents.
 * @param {string} token
 * @returns {string|null} ISO 8601 date string or null if invalid
 */
export function extractExpirationFromJWT(token) {
  try {
    const parts = String(token || "").split(".");
    if (parts.length !== 3) return null;

    let payload = parts[1];
    payload = payload.replace(/-/g, "+").replace(/_/g, "/");
    while (payload.length % 4) {
      payload += "=";
    }

    const decoded = JSON.parse(atob(payload));
    if (!decoded.exp) return null;

    return new Date(decoded.exp * 1000).toISOString();
  } catch {
    return null;
  }
}
